import React from "react";
import {TableCell} from '@aws-amplify/ui-react';

function FramerateCell(props) {
  return (
      <>
        <TableCell className="synamedia-td">
          {
            props.distorted ?
                props.distorted.spec_frame_rate + ' fps'
                :
                ''
          }
        </TableCell>
      </>
  );
}

export default FramerateCell;
